<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><em>Contents</em></h2>
<p class="toc"><a href="#/html/9780230337411_08_map#map"><em>Maps</em></a></p>
<p class="tocb"><a href="#/html/9780230337411_09_pre#pre"><em>Preface: Beneath the Hat</em></a></p>
<table>
<tbody><tr>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_10_int#int">Introduction</a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_10_int#int">The Last City of the Incas: The Sixteenth-Century Conquest</a></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc-part"><a href="#/html/9780230337411_11_pt1#pt1">Part One<br/>The Explorer</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_12_ch1#ch1">Chapter One</a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_12_ch1#ch1">The Black Temple</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_13_ch2#ch2">Chapter Two</a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_13_ch2#ch2">The Ivory Tower</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_14_ch3#ch3">Chapter Three</a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_14_ch3#ch3">The Compass</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_15_ch4#ch4">Chapter Four</a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780230337411_15_ch4#ch4">Into the Andes</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_16_ch5#ch5" title="Link target outside of Sample">Chapter Five</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_16_ch5#ch5" title="Link target outside of Sample">Cuzco, the Navel of the World</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_17_ch6#ch6" title="Link target outside of Sample">Chapter Six</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_17_ch6#ch6" title="Link target outside of Sample">Choqquequirau, the Cradle of Gold</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc1"><span href="#/html/9780230337411_18_ch6bm#pt1int" title="Link target outside of Sample"><em>Interlude: Manco Inca</em></span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc-part"><span href="#/html/9780230337411_19_pt2#pt2" title="Link target outside of Sample">Part Two<br/>The Search</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_20_ch7#ch7" title="Link target outside of Sample">Chapter Seven</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_20_ch7#ch7" title="Link target outside of Sample">Best Laid Plans</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_21_ch8#ch8" title="Link target outside of Sample">Chapter Eight</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_21_ch8#ch8" title="Link target outside of Sample">Dead Man’s Gulch</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_22_ch9#ch9" title="Link target outside of Sample">Chapter Nine</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_22_ch9#ch9" title="Link target outside of Sample">The Discoverers of Machu Picchu</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_23_ch10#ch10" title="Link target outside of Sample">Chapter Ten</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_23_ch10#ch10" title="Link target outside of Sample">The White Temple</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a id="page_viii"></a><span href="#/html/9780230337411_24_ch11#ch11" title="Link target outside of Sample">Chapter Eleven</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_24_ch11#ch11" title="Link target outside of Sample">The Plain of Ghosts</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc1"><span href="#/html/9780230337411_25_ch11bm#pt2int" title="Link target outside of Sample"><em>Interlude: Titu Cusi</em></span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc-part"><span href="#/html/9780230337411_26_pt3#pt3" title="Link target outside of Sample">Part Three<br/>The Resurrectionists</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_27_ch12#ch12" title="Link target outside of Sample">Chapter Twelve</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_27_ch12#ch12" title="Link target outside of Sample">The Deal</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_28_ch13#ch13" title="Link target outside of Sample">Chapter Thirteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_28_ch13#ch13" title="Link target outside of Sample">The Cemetery of the Incas</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_29_ch14#ch14" title="Link target outside of Sample">Chapter Fourteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_29_ch14#ch14" title="Link target outside of Sample">The Debate</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_30_ch15#ch15" title="Link target outside of Sample">Chapter Fifteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_30_ch15#ch15" title="Link target outside of Sample">The Prize</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc1"><span href="#/html/9780230337411_31_ch15bm#pt3int" title="Link target outside of Sample"><em>Interlude: Tupac Amaru</em></span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc-part"><span href="#/html/9780230337411_32_pt4#pt4" title="Link target outside of Sample">Part Four<br/>Bonesmen</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_33_ch16#ch16" title="Link target outside of Sample">Chapter Sixteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_33_ch16#ch16" title="Link target outside of Sample">Between the Poles</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_34_ch17#ch17" title="Link target outside of Sample">Chapter Seventeen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_34_ch17#ch17" title="Link target outside of Sample">Temptation</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_35_ch18#ch18" title="Link target outside of Sample">Chapter Eighteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_35_ch18#ch18" title="Link target outside of Sample">Roads to Ruins</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_36_ch19#ch19" title="Link target outside of Sample">Chapter Nineteen</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_36_ch19#ch19" title="Link target outside of Sample">The Trial of Hiram Bingham</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_37_ch20#ch20" title="Link target outside of Sample">Chapter Twenty</span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780230337411_37_ch20#ch20" title="Link target outside of Sample">Airborne</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc"><span href="#/html/9780230337411_38_bm1#ret" title="Link target outside of Sample">Returns</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc"><span href="#/html/9780230337411_39_bm2#epi" title="Link target outside of Sample">Epilogue</span></p></td>
</tr>
<tr>
<td colspan="2" valign="top"><p class="toc"><span href="#/html/9780230337411_40_bm3#aft" title="Link target outside of Sample">Afterword</span></p></td>
</tr>
</tbody></table>
<p class="toct"><span href="#/html/9780230337411_41_bm4#ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc"><span href="#/html/9780230337411_42_bm5#sou" title="Link target outside of Sample"><em>A Note on Sources</em></span></p>
<p class="toc"><span href="#/html/9780230337411_43_bm6#not" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/html/9780230337411_44_bm7#ind" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230337411_07_toc.vue?0d93bb18